export default "__VITE_ASSET__6gF6ULkN__"